<div class="container-fluid mt-4">
  <h4 class="mb-3"><i class="fi fi-rr-house-chimney"></i> მთავარი გვერდი </h4>
    <div class="row g-4">

      <app-spinner [loading]="load" text="იტვირთება..."></app-spinner>

      <div class="row row-cols-1 row-cols-md-4 g-4">
        <div class="col">
          <div class="card h-100 text-center shadow">
            <div class="card-body">
              <div class="display-4 text-primary mb-2">
                 <i class="fi fi-rr-engine"></i>
              </div>
              <h2 class="card-title mb-3">{{data.parts_count}}</h2>
              <p class="card-text text-muted">ნაწილები</p>
            </div>
          </div>
        </div>
        
        <div class="col">
          <div class="card h-100 text-center shadow">
            <div class="card-body">
              <div class="display-4 text-success mb-2">
                <i class="fi fi-rr-car-alt"></i>
              </div>
              <h2 class="card-title mb-3">{{data.cars_count}}</h2>
              <p class="card-text text-muted">მანქანები</p>
            </div>
          </div>
        </div>
        
        <div class="col">
          <div class="card h-100 text-center shadow">
            <div class="card-body">
              <div class="display-4 text-warning mb-2">
                <i class="fi fi-rr-brand"></i>
              </div>
              <h2 class="card-title mb-3">{{data.marks_count}}</h2>
              <p class="card-text text-muted">ბრენდები</p>
            </div>
          </div>
        </div>
        
        <div class="col">
          <div class="card h-100 text-center shadow">
            <div class="card-body">
              <div class="display-4 text-danger mb-2">
                        <i class="fi fi-rr-box"></i>
              </div>
              <h2 class="card-title mb-3">{{data.orders_count}}</h2>
              <p class="card-text text-muted">შეკვეთები</p>
            </div>
          </div>
        </div>
      </div>
    </div>


<div class="row">
  <div class="col-md-5">

    <form [formGroup]="seoForm" (ngSubmit)="saveSeo()">

      <div class="form-floating mt-5 mb-3">
        <textarea
          class="form-control"
          id="seoKeywords"
          placeholder="keywords"
          formControlName="keywords"
          style="height: 120px;"
        ></textarea>
        <label for="seoKeywords">საძიებო სიტყვები</label>

        <small class="text-danger" *ngIf="seoForm.get('keywords')?.touched && seoForm.get('keywords')?.invalid">
          აუცილებელია
        </small>
      </div>

      <div class="form-floating mb-3">
        <textarea
          class="form-control"
          id="seoDescription"
          placeholder="description"
          formControlName="description"
          style="height: 120px;"
        ></textarea>
        <label for="seoDescription">საძიებო აღწერა</label>

        <small class="text-danger" *ngIf="seoForm.get('description')?.touched && seoForm.get('description')?.invalid">
          აუცილებელია
        </small>
      </div>

      <button class="btn btn-primary" type="submit" [disabled]="loadSave">
        <span *ngIf="!loadSave">შენახვა</span>
        <span *ngIf="loadSave">ინახება...</span>
      </button>

    </form>

  </div>
</div>


</div>

